import { render, staticRenderFns } from "./EditTemplateModels.vue?vue&type=template&id=146118ae&"
import script from "./EditTemplateModels.vue?vue&type=script&lang=js&"
export * from "./EditTemplateModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports